import { useId } from 'react';

export function ChatCanvasIcon() {
  const imageId = useId();

  return (
    <svg width="33" height="33" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath={`url(#${imageId})`}>
        <rect x="0.270264" y="0.5" width="33" height="33" rx="4" fill="#034575" />
        <mask
          id="mask0_2105_1076"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="5"
          y="8"
          width="23"
          height="30"
        >
          <path
            d="M5.97026 12.5C5.97026 10.2909 7.76112 8.5 9.97026 8.5H19.4703L27.5703 17.2V33.5C27.5703 35.7091 25.7794 37.5 23.5703 37.5H9.97027C7.76113 37.5 5.97026 35.7091 5.97026 33.5V12.5Z"
            fill="url(#paint0_linear_2105_1076)"
          />
        </mask>
        <g mask="url(#mask0_2105_1076)">
          <path
            d="M5.97026 12.5C5.97026 10.2909 7.76112 8.5 9.97026 8.5H19.4703L27.5703 17.2V33.5C27.5703 35.7091 25.7794 37.5 23.5703 37.5H9.97027C7.76113 37.5 5.97026 35.7091 5.97026 33.5V12.5Z"
            fill="#F5F5F5"
          />
        </g>
        <path
          d="M19.4703 8.5L27.5703 17.2H23.4703C21.2611 17.2 19.4703 15.4091 19.4703 13.2V8.5Z"
          fill="#E9EAEB"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2105_1076"
          x1="16.7703"
          y1="8.5"
          x2="16.7703"
          y2="37.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.4" />
          <stop offset="1" />
        </linearGradient>
        <clipPath id={imageId}>
          <rect x="0.270264" y="0.5" width="33" height="33" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
